<template>
  <div :class="[$style.example_content_item]">
    <div :class="$style.example_content_item_title">
      {{ title }}
    </div>
    <div :class="$style.example_content_2_items">
      <div
        :class="$style.example_block"
        @click="()=>onCreateReport('project', timeTitleLocales.timeByProjects)"
      >
        <div :class="$style.example_block_title">
          <div :class="$style.text">
            {{ locale(`${timeTitleLocales.timeByProjects}`) }}
          </div>
          <vgp-button
            type="text"
            :small="true"
            :class="$style.example_create_but"
            :label="locale('common_create')"
          />
        </div>
        <div :class="$style.example_block_desc">
          {{ locale(`exmp_chart_time_project_desc`) }}
        </div>
        <div :class="$style.example_block_chart">
          <img
            :class="$style.img"
            :src="'https://cdn.ganttpro.com/app/imgs/reports/reportTimeProject.png'"
          >
        </div>
      </div>
      <div
        :class="$style.example_block"
        @click="()=>onCreateReport('month', timeTitleLocales.timeByMonth)"
      >
        <div :class="$style.example_block_title">
          <div :class="$style.text">
            {{ locale(`${timeTitleLocales.timeByMonth}`) }}
          </div>
          
          <vgp-button
            type="text"
            :small="true"
            :class="$style.example_create_but"
            :label="locale('common_create')"
          />
        </div>
        <div :class="$style.example_block_desc">
          {{ locale(`exmp_chart_time_by_month_desc`) }}
        </div>
        <div :class="$style.example_block_chart">
          <img
            :class="$style.img"
            :src="'https://cdn.ganttpro.com/app/imgs/reports/reportTimeMonth.png'"
          >
        </div>
      </div>
    </div>
    <!-- закомментил, для будущих релизов -->
    <!-- <div :class="$style.example_content_2_items">
      <div
        :class="[$style.example_block, $style.full_size]"
        @click="()=>onCreateReport('timeloglist')"
      >
        <div :class="$style.example_block_title">
          {{ locale(`exmp_chart_time_resource_title`) }}
          <vgp-button
            type="primary"
            :small="true"
            :class="$style.example_create_but"
            :label="locale('common_create')"
          />
        </div>
        <div :class="$style.example_block_desc">
          {{ locale(`exmp_chart_time_resource_desc`) }}
        </div>
        <div :class="$style.example_block_chart">
          <vgp-svg-image
            name="report_time_table"
          />
        </div>
      </div>
    </div> -->
    <div :class="$style.example_content_2_items">
      <div
        :class="$style.example_block"
        @click="()=>onCreateReport('timeloglist', 'exmp_chart_time_log_title')"
      >
        <div :class="$style.example_block_title">
          <div :class="$style.text">
            {{ locale(`exmp_chart_time_log_title`) }}
          </div>
          
          <vgp-button
            type="text"
            :small="true"
            :class="$style.example_create_but"
            :label="locale('common_create')"
          />
        </div>
        <div :class="$style.example_block_desc">
          {{ locale(`exmp_chart_time_log_desc`) }}
        </div>
        <div :class="$style.example_block_chart">
          <img
            :class="$style.img"
            :src="'https://cdn.ganttpro.com/app/imgs/reports/reportTimelog.png'"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import vgpSvgImage from '$$vueCmp/VueIcon/vgpSvgImage.vue';
import reportConstants from '../include/constants';

export default {
  components: {
    vgpSvgImage,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  emits: { onCreateReport: Object },
  data() {
    return {
      locale: __,
      timeTitleLocales: reportConstants.TITLE.time,
    };
  },
  methods: {
    onCreateReport(type, title) {
      this.$emit('onCreateReport', {
        title,
        type,
        routerName: 'timeReports',
      });
    },
  },
};
</script>

<style module src='./../less/reportsMain.less'></style>
